import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  speedDial: {
    position: 'fixed',
    bottom: theme.spacing(3),
    right: theme.spacing(3),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.action.active,
  },
  actions: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr',
  },
  fab: {
    alignSelf: 'flex-end',
  },
}));
